<template>
  <div>
    <span v-for="(color, index) of colors" :key="index">
      <span
        :style="{ backgroundColor: color.bgColor }"
        style="width:20px;height:20px"
        class="inline-block mx-1 rounded-sm cursor-pointer"
        @click="$emit('colorSelected', color)"
      >
      </span>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      colors: [
        {
          bgColor: "#f45b3c",
          textColor: "#fff",
        },
        {
          bgColor: "#fcb2b3",
          textColor: "#000",
        },
        {
          bgColor: "#243047",
          textColor: "#fff",
        },

        {
          bgColor: "#c601ff",
          textColor: "#fff",
        },
        {
          bgColor: "#fc4159",
          textColor: "#000",
        },
        {
          bgColor: "#26d5ff",
          textColor: "#fff",
        },
        {
          bgColor: "#f7c540",
          textColor: "#000",
        },
        {
          bgColor: "#f56474",
          textColor: "#fff",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
